import Moment from 'moment'
import first from 'lodash/first'
import get from 'lodash/get'

import { filterString } from '../helpers/cleanup'
import { WARRANTY_TYPE } from 'constants/warrantyType'

export const generateAnnouncementObject = ({
  user_id,
  address,
  info,
  tenant_pays,
  values,
  insurance_type,
}) => {
  const property = {
    user_id,
    is_published: false,
    address: {
      city: 'Curitiba',
      state: 'Paraná',
      ...address,
    },
    location: {
      latitude: get(address, 'lat.value', 0),
      longitude: get(address, 'lng.value', 0),
    },
    location_deltas: {
      latitude: get(address, 'lat.value', 0),
      longitude: get(address, 'lng.value', 0),
    },
    details: {
      air_conditioning: false,
      barbecue: false,
      bathroom_cabinet: false,
      bed: false,
      fridge: false,
      garden: false,
      gourmet_balcony: false,
      hidro: false,
      kitchen_cabinet: false,
      pet_friendly: false,
      pool: false,
      penthouse: false,
      service_bathroom: false,
      service_room: false,
      stove: false,
      extra_reversible_room: false,
      glass_shower_box: false,
      gas_shower: false,
      room_cabinets: false,
      sofa: false,
      washing_machine: false,
      decorated: false,
    },
    condominium_details: {
      gym: false,
      barbecue: false,
      elevator: false,
      gourmet_area: false,
      building_laundry: false,
      pool: false,
      playground: false,
      concierge_24h: false,
      sports_court: false,
      party_hall: false,
      sauna: false,
    },
    info: info,
    tenant_pays,
    values,
    warranty: {
      insurance_bond: insurance_type === WARRANTY_TYPE.INSURANCE,
      deposit_bond: insurance_type === 'CAUÇÃO',
    },
  }

  return property
}

const getTenants = (users) =>
  users.length > 1 ? [first(users), users.slice(1, users.length)] : [first(users), []]

export const createContractObject = ({ details, landlord, contract, proposition }) => {
  const { tenant_pays, values } = contract

  const momentPayday = Moment(details.payday)

  const end_date = momentPayday.add(details.duration, 'years').format('MM/DD/YYYY')

  const today = Moment()

  const fixed_values = { ...values }
  const fixed_tenant_pays = { ...tenant_pays }

  if (proposition.details.type === WARRANTY_TYPE.INSURANCE) {
    fixed_values.rent = fixed_values.rent * 1.15
  }

  const [nominalTenant, otherTenants] = getTenants(contract.users)

  console.log('🚀 ~ createContractObject ~ contract.address.complement', contract.address.complement)

  const contractObject = {
    property_announcement_id: contract.propertyId,
    landlord: {
      id: landlord.id,
      name: landlord.name,
      email: landlord.email,
      cpf: landlord.cpf,
    },
    tenant: {
      id: nominalTenant.id,
      cpf: nominalTenant.cpf,
      name: nominalTenant.name,
      email: nominalTenant.email,
    },
    details: {
      signing: {
        place: 'Curitiba',
        day: today.format('DD'),
        month: today.format('MM'),
        year: today.format('YYYY'),
      },
      start_date: momentPayday.format('MM/DD/YYYY'),
      end_date,
      payday: momentPayday.format('DD'),
      bond_value: String(parseFloat(proposition.details.bond_value)).replace('.', ','),
      bond_months: String(proposition.details.bond_months),
      insurer: contract.insurance.insurer,
      type: proposition.details.type,
      duration: String(details.duration),
      tenant_pays: fixed_tenant_pays,
      values: fixed_values,
      total_value: parseFloat(values.total),
    },
    property: {
      id: contract.propertyId,
      user_id: landlord.id,
      address: {
        city: 'Curitiba',
        state: 'Paraná',
        ...contract.address,
        complement: contract.address.complement || 'Sem ponto de referência',
      },
      info: contract.info,
      tenant_pays: fixed_tenant_pays,
      values: fixed_values,
    },
    proposition_id: proposition.id,
  }

  if (otherTenants.length > 0) {
    contractObject.tenant_parties = otherTenants
  }

  return contractObject
}


export const createProposalObject = ({ propertyId, details, values, tenant_pays, landlord_id, tenants }) => {
  const { duration, bond_months, bond_value } = details

  const [nominalTenant] = getTenants(tenants)

  const fixed_values = { ...values }

  if (details.type === WARRANTY_TYPE.INSURANCE) {
    fixed_values.rent = fixed_values.rent * 1.15
  }

  const end_date = Moment(details.payday).add(duration, 'years').format('MM/DD/YYYY')

  const momentPayday = Moment(details.payday)

  const proposal = {
    landlord_id,
    tenant_id: nominalTenant.id,
    property_announcement_id: propertyId,
    details: {
      day: momentPayday.format('DD'),
      month: momentPayday.format('MM'),
      year: momentPayday.format('YYYY'),
      warranty_type: details.type === WARRANTY_TYPE.INSURANCE ? 'INSURANCE' : 'SECURITY_DEPOSIT',
      place: 'Curitiba', // TODO: get property city
      payday: momentPayday.format('DD'),
      start_date: momentPayday.format('MM/DD/YYYY'),
      end_date,
      security_deposit_value: bond_value,
      security_deposit_months: bond_months,
      values: { ...values, base_rent: values.rent, other: 0 },
      tenant_pays: {
        ...tenant_pays,
        other: true,
      },
    },
  }

  return proposal
}

export const createPropositionProposal = ({ id, propositionId, contract, proposition }) => {
  const { users, address } = contract

  const [nominalTenant, otherTenants] = getTenants(users)

  const cleanedPhone = filterString(nominalTenant.phone, ['(', ')'])

  const [phone, ddd] = [cleanedPhone.substr(2, cleanedPhone.length - 2), cleanedPhone.substr(0, 2)]

  const other_tenants = otherTenants.map(({ name, cpf }) => ({ name, cpf }))

  const insuranceObject = {
    comission: 15,
    user: {
      id: nominalTenant.id,
      cpf: filterString(nominalTenant.cpf, ['.', '-']),
      name: nominalTenant.name,
      phone,
      ddd,
      address,
      property: {
        id,
        type: proposition.details.type,
        address: contract.address,
      },
      values: contract.values,
    },
    proposition_id: propositionId,
    otherTenants: other_tenants,
  }

  return insuranceObject
}
